import { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import { getUser } from '../../../common/utilities';
import { getClipEditMode } from '../../../common/permissions';
import PlayerTagEditRequestDialog from '../../player/PlayerTagEditRequestDialog';

/**
 * The clip edit ("pen") control, with its permission gate and dialog in one
 * place so every video player can drop it in without repeating the rules.
 *
 * Renders nothing at all when the user may not edit clips, or when there is no
 * current clip to edit.
 *
 * @param {Object} tag - The clip currently playing (e.g. tagList[curIdx])
 * @param {function} t - Translation function
 * @param {function} [onOpen] - Called when the dialog opens, to pause playback
 * @param {function} [onClose] - Called with (updated: boolean) when it closes
 * @param {Object} [sx] - Style overrides for the icon button
 */
const ClipEditButton = ({ tag, t, onOpen, onClose, sx }) => {
    const [open, setOpen] = useState(false);
    const mode = getClipEditMode(getUser());

    if (mode === null || !tag) return null;

    // Managers change the tag directly; coaches file a request for approval.
    const label = mode === 'immediate' ? t('Edit Clip') : t('Request Correction');

    return (
        <>
            <Tooltip title={label}>
                <IconButton
                    aria-label={label}
                    onClick={() => {
                        setOpen(true);
                        if (onOpen) onOpen();
                    }}
                    sx={{ color: '#fff', ...sx }}
                >
                    <EditOutlinedIcon />
                </IconButton>
            </Tooltip>
            <PlayerTagEditRequestDialog
                t={t}
                open={open}
                onClose={(updated) => {
                    setOpen(false);
                    if (onClose) onClose(updated);
                }}
                player={tag}
                cur_player_id={tag?.player_id}
                applyImmediately={mode === 'immediate'}
            />
        </>
    );
};

export default ClipEditButton;
